/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Patient/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Patient({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Content/Profile/ProfileData/Tag/Payer/Patient"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let personIsPatientValueData = fromData.useDataValue({ viewPath,
context: 'person',
path: 'is_patient',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(personIsPatientValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}